<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>MENU</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="pt-0 pr-5">

        <span v-if="activePrompt" >
          <div
            class="p-6"
            v-if="selectedPage && !selectedPage.parent"
          >
            <span class="vs-select--label">Name</span>
            <vs-input
              v-model="menuData[selectedPage.index].title"
              class="mt-1 w-full mb-base"
            />
              <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Navigation</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="menuData[selectedPage.index].show"></vs-switch>
              </vs-col>
              </vs-row>
              <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Menu</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="menuData[selectedPage.index].display"></vs-switch>
              </vs-col>
              </vs-row>
            <!-- <span class="vs-select--label">Link</span>
            <vs-input
              v-model="menuData[selectedPage.index].link"
              class="mt-1 w-full"
            /> -->
          </div>
           <div
            class="p-6"
            v-if="selectedPage && selectedPage.parent"
          >
            <span>Name</span>
            <vs-input
              v-model="
                menuData[selectedPage.parent].menu[selectedPage.index].title
              "
              class="mt-1 w-full mb-base"
            />
              <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Navigation</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="menuData[selectedPage.parent].menu[selectedPage.index].show"></vs-switch>
              </vs-col>
              </vs-row>
              <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Menu</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="menuData[selectedPage.parent].menu[selectedPage.index].dispaly"></vs-switch>
              </vs-col>
              </vs-row>
            <!-- <span>Link</span>
            <vs-input
              v-model="
                menuData[selectedPage.parent].menu[selectedPage.index].link
              "
              class="mt-1 w-full"
            /> -->
          </div>
            <div class="flex flex-wrap items-center p-6" slot="footer">
           <!-- <vs-button class="mr-6" >Submit</vs-button> -->
           <vs-button type="border" class="ml-auto" @click.native="mainView = true">Back</vs-button>
          </div>
        </span>
        <span v-if="mainView">
         <div class="w-full cursor-pointer p-2 font-bold text-primary flex justify-around">
           <small>SITE NEVIGATION</small>
           <span class="flex-inline">
           <!-- <feather-icon  icon="FileIcon" svgClasses="h-4 w-4" class="ml-4"/> -->
            <!-- <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ml-4"/> -->
             <vs-dropdown vs-trigger-click class="cursor-pointer">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <vs-dropdown-menu>
                  <vs-dropdown-item  @click="addPage()">
                    <span class="flex items-center mt-2">
                      <feather-icon
                        icon="FileIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <small  class="font-semibold">New Page</small>
                    </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="addLink()">
                    <span class="flex items-center mt-2">
                      <feather-icon
                        icon="LinkIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2 "
                      />
                      <small class="font-semibold" >New Link</small>
                    </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item  @click="addMenu()">
                    <span class="flex items-center mt-2">
                      <feather-icon
                        icon="FolderIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <small class="font-semibold">New Dropdown</small>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
           </span>
         </div>
      <draggable class="vs-list bordered-items" element="ul" v-model="menuData" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false"> 
        <transition-group type="transition" :name="'flip-list'">
        <!-- <ul class="vs-list bordered-items" > -->
          <li
            v-for="(item, index) in menuData"
            :key="index"
            class="w-full cursor-pointer p-2 font-semibold"
            @mouseover="mouseOver(index,'')"
            @mouseleave="mouseLeave(index,'')"
            
            :ref="'li-with-'+index+'-'"
            v-if="item.display || showHidden"
          >
            <span class="flex items-center" >
              <feather-icon v-if="item.type==='dropdown'" icon="FolderIcon" svgClasses="h-5 w-5" class="ml-4" />
              <feather-icon v-if="item.type==='link'" icon="LinkIcon" svgClasses="h-5 w-5" class="ml-4" />
              <feather-icon v-if="item.title==='Home' && item.type==='page'" icon="HomeIcon" svgClasses="h-5 w-5" class="ml-4"/>
              <feather-icon v-if="!item.title=='Home' && item.type==='page'" icon="HomeIcon" svgClasses="h-5 w-5" class="ml-4"/>
              <span class="ml-3" @click="setPage(item.page)" v-if="item.type!=='link'">{{ item.title }}</span>
              <span class="ml-3" v-else>{{ item.title }}</span>
              <span class="ml-auto mr-8 hidden" :ref="'div-with-'+index+'-'" >
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <feather-icon icon="SettingsIcon" svgClasses="h-5 w-5" />
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="Action(index, 'Page', 'rename')">
                      <span class="flex items-center mt-2">
                        <feather-icon
                          icon="EditIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <small  class="font-semibold" 
                          >Rename</small
                        >
                      </span>
                      </vs-dropdown-item>
                      <vs-dropdown-item v-if="item.type==='page'"  @click="Action(index, 'Page', 'copy')">
                      <span class="flex items-center mt-2">
                        <feather-icon
                          icon="CopyIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <small  class="font-semibold"
                          >Duplicate</small
                        >
                      </span>
                      </vs-dropdown-item>
                      <vs-dropdown-item  @click="Action(index, 'Page', 'delete')">
                      <span class="flex items-center mt-2 text-danger">
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <small  class="font-semibold">Delete</small>
                      </span>
                    </vs-dropdown-item>
                      <vs-dropdown-item  @click="Action(index, 'Page', 'display')">
                      <span class="flex items-center mt-2">
                        <feather-icon
                          icon="ToggleLeftIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <small class="font-semibold">Show in Menu</small>
                      </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="item.type==='dropdown'"  @click="Action(index, 'Page', 'page')">
                      <span class="flex items-center mt-2">
                      <feather-icon
                        icon="FileIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <small  class="font-semibold">New Page</small>
                    </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="item.type==='dropdown'"  @click="Action(index, 'Page', 'link')">
                      <span class="flex items-center mt-2">
                      <feather-icon
                        icon="LinkIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <small  class="font-semibold">New Link</small>
                    </span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </span>
            </span>
            <!-- <ul class="vs-list ml-5"> -->
            <draggable  v-if="item.menu" v-model="item.menu"  class="vs-list ml-5" element="ul" :options="dragOptions" :move="onMove" :list="item.menu">
              <transition-group  :name="'flip-list'">
              <li
                v-for="(menu, ind) in item.menu"
                :key="ind"
                class="w-full cursor-pointer ml-2 p-2"
                @mouseover="mouseOver(index,ind)"
                @mouseleave="mouseLeave(index,ind)"
                :ref="'li-with-'+index+'-'+ind"
                v-if="showHidden || menu.display"
              >
                <span class="flex items-center" >
                  <feather-icon icon="FileIcon" svgClasses="h-5 w-5" />
                  <span class="ml-1" @click="setPage(menu.page)" v-if="menu.type!=='link'">{{ menu.title }}</span>
                  <span class="ml-1" v-else>{{ menu.title }}</span>
                  <ul></ul>
                  <span class="ml-auto mr-12 hidden" :ref="'div-with-'+index+'-'+ind" >
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" />
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="MenuAction(index,ind,'menu', 'rename')">
                          <span class="flex items-center mt-2">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small  class="font-semibold" >Rename</small>
                          </span>
                          </vs-dropdown-item>
                          <vs-dropdown-item  @click="MenuAction(index,ind,'menu', 'copy')">
                          <span class="flex items-center mt-2">
                            <feather-icon
                              icon="CopyIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small  class="font-semibold">Duplicate</small>
                          </span>
                          </vs-dropdown-item>
                          <vs-dropdown-item @click="MenuAction(index,ind,'menu', 'delete')">
                          <span class="flex items-center mt-2 text-danger" >
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small class="font-semibold">Delete</small>
                          </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item  @click="MenuAction(index,ind,'menu', 'display')">
                      <span class="flex items-center mt-2">
                        <feather-icon
                          icon="ToggleLeftIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <small class="font-semibold">Show in Menu</small>
                      </span>
                    </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </span>
                </span>
              </li>
              </transition-group>
              </draggable>
            <!-- </ul> -->
            <!-- <vs-divider></vs-divider> -->
          </li>
           </transition-group>
        </draggable>
        <!-- </ul> -->
        <div class="p-6">
          <vs-row class="mt-5 mb-2" >
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
          <label>Show Hidden Menu</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
            <vs-switch v-model="showHidden"></vs-switch>
          </vs-col>
          </vs-row>
          </div>
        </span>
        <span v-if="isPage">
        <small class="font-bold text-black p-6 ">Add New Page</small><br>
        <div
            class="p-6 pt-3"
          >
            <span class="vs-select--label" >Page Title</span>
            <vs-input
              class=" w-full mb-5"
              placeholder="My Blog"
              v-model="dataPage"
            />
             <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Navigation</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="dataShow"></vs-switch>
              </vs-col>
              </vs-row>
          </div>
            <div class="flex flex-wrap items-center p-6 pt-0" slot="footer">
            <vs-button class="mr-6" @click.native="createPage" :disabled="!isPageValid">Create</vs-button>
            <vs-button type="border" color="danger" @click.native="mainView = true">Cancel</vs-button>
            </div>
        </span>
        <span v-if="isLink">
          <small class="font-bold text-black p-6">ADD NEW LINK</small><br>
          <div
            class="p-6 pt-3"
          >
            <span class="vs-select--label" >Link Title</span>
            <vs-input
              class=" w-full mb-2"
              placeholder="My Blog"
              v-model="dataLink"
            />
            <span class="vs-select--label">Website Url</span>
            <vs-input
              class="w-full"
              placeholder="https://"
              v-model="dataUrl"
            />
             <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Navigation</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="dataShow"></vs-switch>
              </vs-col>
              </vs-row>
          </div>
            <div class="flex flex-wrap items-center p-6 pt-0" slot="footer">
            <vs-button class="mr-6" @click.native="createLink" :disabled="!isLinkValid">Create</vs-button>
            <vs-button type="border" color="danger" @click.native="mainView = true">Cancel</vs-button>
            </div>
        </span>
         <span v-if="isMenu">
          <small class="font-bold text-black p-6">ADD NEW DROPDOWN</small><br>
         <div
            class="p-6 pt-3"
          >
            <label class="vs-select--label">Menu Title</label>
            <vs-input
              class="w-full mb-2"
              placeholder="About Us"
              v-model="dataMenu"
            />
            <!-- <vs-select  label="Select Dropdown Pages" multiple  v-model="dataPages" class="mt-5 w-full" autocomplete>
            <vs-select-item :key="item.id" :value="item" :text="item.title" v-for="item in pagesMenu" />
           </vs-select> -->
            <vs-row class="mt-5 mb-2" >
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
              <label>Show in Navigation</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                <vs-switch v-model="dataShow"></vs-switch>
              </vs-col>
              </vs-row>
          </div>
        <div class="flex items-center ml-6" slot="footer">
          <vs-button class="mr-6" @click.native="createDropdown" :disabled="!isMenuValid">Create</vs-button>
            <vs-button type="border" color="danger" @click.native="mainView = true">Cancel</vs-button>
          </div>
        </span>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!-- <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button> -->
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { SAVE_WEB_MENU,COPY_WEB_PAGE,SAVE_NEW_WEBPAGE ,SAVE_MENU_SECTION} from "@/graphql";
import { VTree, VSelectTree } from "vue-tree-halower";
import draggable from 'vuedraggable'
import {
GET_MENU_TEMP
} from "@/graphql";

import {
  main_navbar,
  main_footer,
  base_style,
  main_scripts,
  main_menu,
  SAVE_MENU_FILE
} from "../grapesjs/navbar";


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    VTree,
    VSelectTree,
      draggable,
  },
  data() {
    return {
       menu_temp:null,
       menuData:null,
       showHidden:false,


      //   menuData: [
      //   {
      //     id: "1",
      //     type: "page",
      //     title: "Home",
      //     page:'home.html',
      //     name:'home',
      //     link: "1",
      //     show:"true"
      //   },
      //   {
      //     id: "2",
      //     type: "page",
      //     title: "About",
      //     page:'about.html',
      //     name:'about',
      //     link: "2",
      //     show:"true"
      //   },
      //   {
      //     id: "3",
      //     type: "page",
      //     title: "Programs",
      //     page:'curriculum.html',
      //     name:'programs',
      //     link: "3",
      //     show:"true"
      //   },
      //   {
      //     id: "4",
      //     type: "page",
      //     title: "Enrollment",
      //     page:'enrollment.html',
      //     name:'enrollment',
      //     link: "4",
      //     show:"true"
      //   },
      //   {
      //     id: "5",
      //     type: "page",
      //     title: "Parents",
      //     page: "kiddiecams.html",
      //     name:'kiddiecams',
      //     link: "5",
      //     show:"true"
      //   },
      //   {
      //     id: "6",
      //     type: "dropdown",
      //     title: "Team",
      //     page: "dropdown",
      //     show:"true",
      //     link: "3",
      //       menu: [
      //       {
      //         type: "page",
      //         title: "Staff Members",
      //         link: "menu1",
      //         page: "staff.html",
      //         name:'staff',
      //         show:"true",
      //       },
      //       {
      //         type: "page",
      //         title: "Open Positions",
      //         link: "menu2",
      //         page: "contact.html",
      //         name:'contact',
      //         show:"true",
      //       }
      //     ],
      //   },
      //   {
      //     id: "7",
      //     type: "page",
      //     title: "Cameras",
      //     link: "8",
      //     page: "kiddiecams.html",
      //     name:'kiddiecams',
      //     show:"true"
      //   },
      //   {
      //     id: "8",
      //     type: "page",
      //     title: "Contact",
      //     link: "9",
      //     page: "contact.html",
      //     name:'contact',
      //     show:"true"
      //   },
      // ],
      
        // menuData:[
        //     {
        //         id: "1",
        //         type: "page",
        //         title: "Home",
        //         page: 'home.html',
        //         name: 'home',
        //         link: "/",
        //         show: "true",
        //     },
        //     {
        //         id: "2",
        //         type: "dropdown",
        //         title: "About",
        //         page: 'about.html',
        //         name: 'about',
        //         link: "2",
        //         show: "true",
        //         menu: [
        //             {
        //                 type: "page",
        //                 title: "About Us",
        //                 link: "/about/",
        //                 page: "",
        //                 name: 'about us',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Welcome",
        //                 link: "/about/welcome.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "General Information",
        //                 link: "/about/general.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Tuition &amp; Fees",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Discipline",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title:"Health &amp;Safety",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },

        //             {
        //                 type: "page",
        //                 title: "Meals &amp; Menu",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //         ],
        //     },
        //     {
        //         id: "3",
        //         type: "dropdown",
        //         title: "Programs",
        //         page: 'curriculum.html',
        //         name: 'programs',
        //         link: "3",
        //         show: "true",
        //         menu: [
        //             {
        //                 type: "page",
        //                 title: "All Programs",
        //                 link: "/about/",
        //                 page: "",
        //                 name: 'about us',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Infants",
        //                 link: "/about/welcome.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Toddlers",
        //                 link: "/about/general.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Preschool",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "School Age",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Summer Camp",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //         ],
        //     },
        //     {
        //         id: "4",
        //         type: "dropdown",
        //         title: "Enrollment",
        //         page: 'enrollment.html',
        //         name: 'enrollment',
        //         link: "4",
        //         show: "true",
        //         menu: [
        //             {
        //                 type: "page",
        //                 title: "Information",
        //                 link: "/about/",
        //                 page: "",
        //                 name: 'about us',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Documents",
        //                 link: "/about/welcome.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "FAQs",
        //                 link: "/about/general.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Parent Handbook",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //         ],
        //     },
        //     {
        //         id: "5",
        //         type: "dropdown",
        //         title: "Parents",
        //         page: "kiddiecams.html",
        //         name: 'kiddiecams',
        //         link: "5",
        //         show: "true",
        //         menu: [
        //             {
        //                 type: "page",
        //                 title: "News",
        //                 link: "/about/",
        //                 page: "",
        //                 name: 'about us',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Holidays &amp; Closures",
        //                 link: "/about/welcome.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Calendar",
        //                 link: "/about/general.phtml",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Parent Testimonials",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Gallery",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //         ],
        //     },
        //     {
        //         id: "6",
        //         type: "dropdown",
        //         title: "Team",
        //         page: "dropdown",
        //         show: "true",
        //         link: "3",
        //         menu: [
        //             {
        //                 type: "page",
        //                 title: "Staff Members",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Open Positions",
        //                 link: "menu2",
        //                 page: "contact.html",
        //                 name: 'contact',
        //                 show: "true",
        //             }
        //         ],
        //     },
        //     {
        //         id: "7",
        //         type: "dropdown",
        //         title: "Cameras",
        //         link: "8",
        //         page: "kiddiecams.html",
        //         name: 'kiddiecams',
        //         show: "true",
        //         menu: [
        //             {
        //                 type: "page",
        //                 title: "Parent Login",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Getting Started",
        //                 link: "menu2",
        //                 page: "contact.html",
        //                 name: 'contact',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Tech Support",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Password Authorization",
        //                 link: "menu2",
        //                 page: "contact.html",
        //                 name: 'contact',
        //                 show: "true",
        //             }
        //         ],
        //     },
        //     {
        //         id: "8",
        //         type: "dropdown",
        //         title: "Contact",
        //         link: "9",
        //         page: "contact.html",
        //         name: 'contact',
        //         show: "true",
        //         menu: [
        //            {
        //                 type: "page",
        //                 title: "Contact Us",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             },
        //             {
        //                 type: "page",
        //                 title: "Schedule a Tour",
        //                 link: "menu1",
        //                 page: "staff.html",
        //                 name: 'staff',
        //                 show: "true",
        //             }
        //         ],
        //     },
        // ],
      dataId: null,
      selectedPage: null,
      initSelected: ["node-1"],
      treeData: [
        {
          title: "Menu",
          expanded: false,
          async: true,
        },
      ],

      htmlstring: `<div class="navbar container-fluid main-menu navbar-expand-xl" data-gjs-type="dltable"> <div class="container"> <!-- logo --><a href="/" class="nav-brand nav-brand-center"><span><img src="https://dev3.barqsol.com/basic/images/advantage-elc-logo.png" alt="Advantage Logo" title="Advantage Logo" class="d-block mx-auto" /></span></a> <!-- Navbartoggler --><button type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"><span class="navbar-toggle-icon"><i class="fas fa-bars"></i></span></button> <div id="navbarResponsive" class="collapse navbar-collapse"> </div> <!--collapse --> <div class="outer-box clearfix"> </div> </div><!-- /container --> </div>`,
      activePrompt: false,
      mainView: true,
      isPage:false,
      isLink:false,
      isMenu:false,
      dataPage:null,
      dataShow:true,
      dataLink:null,
      dataUrl:null,
      dataMenu:null,
      dataPages:[],
      menuFileData:null,
      nameCount:0,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      isMenuPage:false,
      isMenuPageIndex:null,
        editable:true,
      isDragging: false,
      delayedDragging:false
    };
  },
  watch: {
     isDragging (newValue) {
      if (newValue){
        this.delayedDragging= true
        return
      }
      this.$nextTick( () =>{
           this.delayedDragging =false
      })
    },
    menuData: {
      handler(val, oldVal) {
        // console.log(val);
        if(this.menu_temp && this.menuData){
            var menuData=val
            var html=null
            var url = localStorage.getItem('web-data-url')
            eval(this.menu_temp);
            this.createMenu(html)
            // this.$emit('setMenuData',val)
            // this.SaveMenuData(val)
          }
          

        //  this.$emit("setMenu", html);
      },
      deep: true,
    },
    isSidebarActive(val) {
      if(val){
            this.menuData=this.getMenus
      }
      // if (!val) return;
      // if (Object.entries(this.data).length === 0) {
      //   this.initValues();
      //   this.$validator.reset();
      // } else {
      //   const {} = JSON.parse(JSON.stringify(this.data));

      //   this.initValues();
      // }
    },
    mainView(val){
        if(val){
            this.activePrompt=false
            this.isPage=false
            this.isLink=false
            this.isMenu=false
            this.dataPage=null
            this.dataLink=null
            this.dataUrl=null
            this.dataMenu=null
            this.dataPages=[]
        }
    },
    activePrompt(val){
        if(val){
            this.mainView=false
            this.isPage=false
            this.isLink=false
            this.isMenu=false
        }
    },
    isPage(val){
        if(val){
            this.mainView=false
            this.activePrompt=false
            this.isLink=false
            this.isMenu=false
            this.dataShow=true
        }
    },
    isLink(val){
        if(val){
            this.mainView=false
            this.activePrompt=false
            this.isPage=false
            this.isMenu=false
            this.dataShow=true
        } 
    },
    isMenu(val){
       if(val){
            this.mainView=false
            this.activePrompt=false
            this.isLink=false
            this.isPage=false
            this.dataShow=true
        } 
    }
  },
  computed: {
    dragOptions () {
      return  {
        animation: 1,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      };
    },
    pagesMenu(){
          if(this.menuData)
          {
              var all_menu = [];
              var allMenu=this.menuData
              allMenu.forEach(menu => {
                if(menu.type==='page'){
                   all_menu.push(menu)
                }
                else{
                  menu.menu.forEach(subMenu => {
                     all_menu.push(subMenu)
                  });
                }
                
              });
              return all_menu;
          }
    },
    getMenus(){
      var store_menu = {...this.$store.getters.getBuilderMenu}
         return store_menu.menu
    },
    isPageValid () {
      return !this.errors.any() && this.dataPage 
    },
    isLinkValid () {
      return !this.errors.any() && this.dataLink && this.dataUrl 
    },
    isMenuValid () {
      return !this.errors.any() && this.dataMenu 
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() && this.dataName && this.dataHtml && this.dataExt
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
onMove ({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    setPage(page){
         var site={
           'sitePage':page,
           'siteName':this.$route.params.siteName
         }
         console.log(site);
         console.log(this.$route.params.siteName)
         this.$emit("setPage", site);
    },
    createLink(){
       let link = {
          id : new Date().valueOf(),
          type: "link",
          title: this.dataLink,
          link: this.dataUrl,
          show:this.dataShow,
          display:true
          }
       if(this.isMenuPage){
          this.menuData[this.isMenuPageIndex].menu.push(link)  
      }
      else{
        this.menuData.push(link)    
      }
      this.mainView=true
    },
    createDropdown(){
      let menu=[]
        this.dataPages.forEach(element => {
         menu.push(element)
       });
        var page = this.getPageName(this.dataMenu);
        let link = {
          id : new Date().valueOf(),
          type: "dropdown",
          page:  page,
          title: this.dataMenu,
          show:  this.dataShow,
          path:  "/"+page+"/",
          display:true,
          menu:menu
        }
      this.menuData.push(link)
      this.mainView=true
    },
    getPageName(name){
      const arr = [];
      for (let i = 0; i < this.menuData.length; i++) {
        const element = this.menuData[i];
         arr.push(element.page)
         if(element.page==='dropdown'){
         for (let j = 0; j < element.menu.length; j++) {
           const subMenu = element.menu[j];
             arr.push(subMenu.page)
           }
         }
      }
      name = name.toLowerCase().replaceAll(" ", "_")
      var input = name;
      if(arr.indexOf(input) < 0){
        var new_page = input
      }
      else{
      var regex = new RegExp(input);
      var matched = arr.filter((x) => x.match(regex))
      var highest = 0
      matched.forEach(m => {
          var s = m.split('-')[1]
          if(s>highest){
              highest = s
          }
      });
          var new_index = parseInt(highest)+1
          var new_page = input+'-'+new_index
      }
      return new_page;
      // this.nameCount++
      // name = name.replace(" ", "-")
      // var exist = false
      // for (let i = 0; i < this.menuData.length; i++) {
      //   const element = this.menuData[i];
      //    if(element.page===name){
      //        exist=true
      //        break
      //    }
      //    if(element.page==='dropdown'){
      //    for (let j = 0; j < element.menu.length; j++) {
      //      const subMenu = element.menu[j];
      //       if(subMenu.page===name){
      //        exist=true
      //        break
      //       }
      //      }
      //    }
      // }
      //   if(exist){
      //      console.log(exist)
      //      name=name+"-"+this.nameCount
      //      return this.getPageName(name)
      //   }
      //   else{
      //     this.nameCount=0
      //     return name;
      //   }
 
    },
    createPage(){ 
    if(this.dataPage){
      var page = this.getPageName(this.dataPage);
              var new_id =  new Date().valueOf()
              var newPage =
                      {
                        id: new_id,
                        type: "page",
                        title: this.dataPage,
                        page:  page,
                        path:  "/",
                        show:  this.dataShow,
                        display:true
                      }

             if(this.isMenuPage){
                  newPage.path=this.menuData[this.isMenuPageIndex].path
                  this.menuData[this.isMenuPageIndex].menu.push(newPage)  
             }
              else{
              
                  this.menuData.push(newPage)    
              }
              this.mainView=true
  }


                  

                //  this.$apollo
                // .mutate({
                // mutation: SAVE_NEW_WEBPAGE,
                // variables: {
                //     name:this.dataPage,
                //     // content:  base_style+"<br>"+main_navbar+"<br>"+main_footer+" "+main_scripts,
                //     content: "<div>New Page</div>",
                //     ext:".html"
                // }
                // })
                // .then(response => {
                // if(response.data.saveNewWebPage.status==='Success'){
                //   var newPage =
                //       {
                //         id: (this.menuData.length+1),
                //         type: "page",
                //         title: this.dataPage,
                //         page:  this.dataPage+".html",
                //         name:  this.dataPage,
                //         link:  this.dataPage+".html",
                //         show:  this.dataShow
                //       }
                //   this.menuData.push(newPage)
                //   this.mainView=true
                // }
                // else{
                //   alert("enter new name")
                // }
                // }).catch(error => {
                // console.log(error)
                // })


      // if(this.dataPage){
      //   if(this.dataPage==='new'){
      //     this.addLink()
      //     // this.isLink=true
      //   }
        //  else{
        //    var newPage = {...this.menuData[this.dataPage]}
        //    this.menuData.push(newPage)
        //    this.mainView = true
        //    this.dataPage = null
        //   }
      // }
      // else{
      //  alert("select the option")
      // }
    },
    addPage(){
       this.isPage=true
       this.isMenuPage=false
       this.isMenuPageIndex=null
    },
    addMenu(){
      this.isMenu=true
    },
     addLink(){
      this.isLink=true
       this.isMenuPage=false
       this.isMenuPageIndex=null
    },
    mouseOver: function (parent,node) {
           var referenceIcon=`div-with-${parent}-${node}`
           var referenceLi=`li-with-${parent}-${node}`
           const icon_element = this.$refs[referenceIcon]
           const li_element = this.$refs[referenceLi]
           icon_element[0].classList.remove('hidden');
           li_element[0].classList.add('menuHover');
          //  li_element[0].classList.add('text-white');
    },
    mouseLeave: function (parent,node) {
           var referenceIcon=`div-with-${parent}-${node}`
           var referenceLi=`li-with-${parent}-${node}`
           const icon_element = this.$refs[referenceIcon]
           const li_element = this.$refs[referenceLi]
            icon_element[0].classList.add('hidden');
            li_element[0].classList.remove('menuHover');    
            // li_element[0].classList.remove('text-white');
    },
    Action(index, type, action) {
      if (action === "rename" || action === "display") {
        this.activePrompt = true;
        let page = { parent: false, index: index };
        this.selectedPage = page;
      }
      if (action === "copy") {
         var pages=[]
         this.menuData.forEach(page => {
            if(page.name===this.menuData[index].name){
                pages.push(page)
            }
            if(page.type==="dropdown")
               for (let i = 0; i < page.menu.length; i++) {
                  if(page.menu[i].name===this.menuData[index].name){
                          pages.push(page)
                      }
               }
         });
          var newPage = {...this.menuData[index]}
          if(pages.length > 0){   
          newPage.page  = pages.length==1 ? this.menuData[index].name+"-1.html" : this.menuData[index].name+"-"+(pages.length+1)+".html"
          var page_name = pages.length==1 ? this.menuData[index].name+"-1" : this.menuData[index].name+"-"+(pages.length+1)
          }
          let i = index + 1;
          this.menuData.splice(i, 0, newPage);
          this.activePrompt = true;
          let page = { parent: false, index: i };
          this.selectedPage = page;
          this.duplicatePage(this.menuData[index].page,page_name)
      }
       if (action === "delete") {
         if(this.menuData[index].menu && this.menuData[index].menu.length > 0){
                this.$vs.notify({
                color: 'danger',
                title: "Page",
                position: 'top-right',
                text: 'Can not delete, first delete all sub pages'
            })
         } 
         else{
             this.menuData.splice(index, 1);
         }
           
      }
       if (action === "page") {
          this.isPage=true
          this.isMenuPage=true
          this.isMenuPageIndex=index
      }
      if (action === "link") {
          this.isLink=true
          this.isMenuPage=true
          this.isMenuPageIndex=index
      }
      // if (action === "delete") {
      //      if(this.menuData[index].type==="dropdown"){
      //         this.menuData.splice(index, 1);
      //      }
      //      else{
      //          let page = this.menuData[index].page
      //         //  this.deletePage(page)
      //          this.menuData.splice(index, 1);
      //      }
      // }
    },
      deletePage(){
        this.$apollo
          .mutate({
            mutation: DELETE_WEB_PAGE,
            variables: {
              page:page
            }
          })
          .then(response => {
            console.log(response)
          }).catch(error => {
            console.log(error)
          })
    },
    duplicatePage(old_page,page_name){
      if(old_page && page_name){
           this.$apollo
          .mutate({
            mutation: COPY_WEB_PAGE,
            variables: {
              page:old_page,
              name:page_name
            }
          })
          .then(response => {
            console.log(response)
          }).catch(error => {
            console.log(error)
          })
       }
    },
    
    MenuAction(parent,node,type,action){
       if (action === "rename" || action === "display") {
              this.activePrompt = true;
              let page = { parent: parent, index: node };
              console.log(page)
              this.selectedPage = page;
       }
       if (action === "copy") {
            var pages=[]
         this.menuData.forEach(page => {
            if(page.name===this.menuData[parent].menu[node].name){
                pages.push(page)
            }
            if(page.type==="dropdown")
               for (let i = 0; i < page.menu.length; i++) {
                  if(page.menu[i].name===this.menuData[parent].menu[node].name){
                          pages.push(page)
                      }
               }
         });
          var newMenu = {...this.menuData[parent].menu[node]}
           if(pages.length > 0){   
           newMenu.page  = pages.length==1 ? this.menuData[parent].menu[node].name+"-1.html" : this.menuData[parent].menu[node].name+"-"+(pages.length+1)+".html"
           var page_menu = pages.length==1 ? this.menuData[parent].menu[node].name+"-1" : this.menuData[parent].menu[node].name+"-"+(pages.length+1)
          }
          this.menuData[parent].menu.splice(node + 1, 0, newMenu);
          this.activePrompt = true;
          let page = { parent: parent, index: node + 1 };
          this.selectedPage = page;
          this.duplicatePage(this.menuData[parent].menu[node].page,page_menu)
        }
        if (action === "delete") {
          let page = this.menuData[parent].menu[node].page
          // this.deletePage(page)
          this.menuData[parent].menu.splice(node, 1);
        }
    },
    // Action(n, p, i, action) {
    //   if (action === "rename") {
    //     if (p) {
    //       this.activePrompt = true;
    //       let parent = p.id - 1;
    //       let page = { parent: parent, index: i };
    //       this.selectedPage = page;
    //     } else {
    //       this.activePrompt = true;
    //       let page = { parent: false, index: i };
    //       this.selectedPage = page;
    //     }
    //   }
    //   if (action === "copy") {
    //     if (p) {
    //       n.selected = false;
    //       var newMenu = { ...n };
    //       // p.menu.push(newMenu)
    //       p.menu.splice(i + 1, 0, newMenu);
    //       this.activePrompt = true;
    //       let parent = p.id - 1;
    //       let page = { parent: parent, index: i + 1 };
    //       this.selectedPage = page;
    //     } else {
    //       console.log(n);
    //       n.selected = false;
    //       var newPage = { ...n };
    //       newPage.id = this.menuData.length + 1;

    //       // this.menuData.push(newPage)
    //       let index = i + 1;
    //       this.menuData.splice(index, 0, newPage);
    //       this.activePrompt = true;
    //       let page = { parent: false, index: index };
    //       this.selectedPage = page;
    //     }
    //   }
    // },
    acceptAlert() {
      this.$vs.notify({
        color: "success",
        title: "Accept Selected",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    close() {
      this.activePrompt = false;
      // this.$vs.notify({
      //   color:'danger',
      //   title:'Close Selected',
      //   text:'Lorem ipsum dolor sit amet, consectetur'
      // })
    },
    // getNode(e) {
    //   console.log(e, "asdasd");
    // },
    // nodechecked(node, v) {
    //   alert("that a node-check envent ..." + node.title + v);
    // },
    // tpl(...args) {
    //   let { 0: node, 2: parent, 3: index } = args;
    //   let titleClass = node.selected
    //     ? "node-title node-selected"
    //     : "node-title";
    //   let pro = false;
    //   if (node.searched) titleClass += " node-searched";
    //   if (!node.hasOwnProperty("selected")) {
    //     this.$set(node, "selected", pro);
    //   } else {
    //     pro = node.selected;
    //     //  console.log(pro)
    //     this.$set(node, "selected", pro);
    //     //  node.children.push(...pro)
    //   }
    //   if (pro) {
    //     return (
    //       <span>
    //         <span
    //           class={titleClass}
    //           domPropsInnerHTML={node.title}
    //           onClick={() => {
    //             this.$refs.tree.nodeSelected(node);
    //           }}
    //         ></span>

    //         <vs-dropdown vs-trigger-click class="cursor-pointer">
    //           <feather-icon
    //             icon="SettingsIcon"
    //             svgClasses="h-4 w-4"
    //             style="margin-left:200px"
    //           />

    //           <vs-dropdown-menu>
    //             <vs-dropdown-item>
    //               <span class="flex items-center mt-2">
    //                 <feather-icon
    //                   icon="EditIcon"
    //                   svgClasses="h-4 w-4"
    //                   class="mr-2"
    //                 />
    //                 <span
    //                   onClick={() => this.Action(node, parent, index, "rename")}
    //                 >
    //                   Rename
    //                 </span>
    //               </span>
    //               <span class="flex items-center mt-2">
    //                 <feather-icon
    //                   icon="CopyIcon"
    //                   svgClasses="h-4 w-4"
    //                   class="mr-2"
    //                 />
    //                 <span
    //                   onClick={() => this.Action(node, parent, index, "copy")}
    //                 >
    //                   Duplicate
    //                 </span>
    //               </span>
    //               <span class="flex items-center mt-2 text-danger">
    //                 <feather-icon
    //                   icon="TrashIcon"
    //                   svgClasses="h-4 w-4"
    //                   class="mr-2"
    //                 />
    //                 <span
    //                   onClick={() =>
    //                     this.$refs.tree.delNode(node, parent, index)
    //                   }
    //                 >
    //                   Delete
    //                 </span>
    //               </span>
    //             </vs-dropdown-item>
    //           </vs-dropdown-menu>
    //         </vs-dropdown>
    //       </span>
    //     );
    //   } else {
    //     return (
    //       <span>
    //         <span
    //           class={titleClass}
    //           domPropsInnerHTML={node.title}
    //           onClick={() => {
    //             this.$refs.tree.nodeSelected(node);
    //           }}
    //         ></span>
    //       </span>
    //     );
    //   }
    // },
    // asyncLoad(node) {
    //   console.log(node);
    //   const { checked = false } = node;
    //   // this.$set(node, 'loading', true)
    //   // let pro = await new Promise(resolve => {
    //   //   setTimeout(resolve, 2000, [{title: 'test1', async: true}, {title: 'test2', async: true}, {title: 'test3'}])
    //   // })

    //   if (!node.hasOwnProperty("menu")) {
    //     this.$set(node, "children", []);
    //   } else {
    //     let pro = node.menu;
    //     console.log(pro);
    //     this.$set(node, "children", pro);
    //     //  node.children.push(...pro)
    //   }

    //   // // this.$set(node, 'loading', false)
    //   if (checked) {
    //     this.$refs.tree.childCheckedHandle(node, checked);
    //   }
    // },
    createMenu(htmlstring) {
      // console.log(this.menuData)
      let doc = new DOMParser().parseFromString(htmlstring, "text/html");
      var x = doc.getElementsByClassName("sb-menu")
      x[0].setAttribute("kvsb-data","sb-menu");
      // doc.getElementById("navbarResponsive").setAttribute("kvdb-data","16345475289049");
      // var parent_div = doc.getElementById("navbarResponsive");
      // var ul = doc.createElement("UL");
      // ul.classList.add("navigation", "clearfix", "navbar-nav");
      // var ul2 = doc.createElement("UL");
      // ul2.classList.add("navigation", "clearfix", "navbar-nav", "ml-auto");
      // // console.log(ul)
      // this.menuData.forEach(function (element, index) {
      //   if (element.type === "page") {
      //     var li = doc.createElement("LI");
      //     // console.log(li)
      //     li.classList.add("nav-item");
      //     var nav_link = doc.createElement("a");
      //     nav_link.classList.add("nav-link");
      //     nav_link.href = element.link;
      //     var link_text = document.createTextNode(element.title);
      //     nav_link.appendChild(link_text);
      //     // console.log(nav_link)
      //     li.appendChild(nav_link);
      //     if (index < 4) {
      //       ul.appendChild(li);
      //     } else {
      //       ul2.appendChild(li);
      //     }
      //   } else {
      //     var li = doc.createElement("LI");
      //     // console.log(li)
      //     li.classList.add("nav-item", "dropdown");
      //     var nav_link = doc.createElement("a");
      //     nav_link.classList.add("nav-link", "dropdown-toggle");
      //     nav_link.href = "#";
      //     nav_link.setAttribute("data-toggle", "dropdown");
      //     nav_link.setAttribute("aria-haspopup", "true");
      //     nav_link.setAttribute("aria-expanded", "false");
      //     var link_text = document.createTextNode(element.title);
      //     nav_link.appendChild(link_text);
      //     li.appendChild(nav_link);
      //     var dropdown_div = doc.createElement("div");
      //     dropdown_div.classList.add("dropdown-menu");
      //     element.menu.forEach((menu) => {
      //       var drop_link = doc.createElement("a");
      //       drop_link.classList.add("dropdown-item");
      //       drop_link.href = menu.link;
      //       var drop_text = document.createTextNode(menu.title);
      //       drop_link.appendChild(drop_text);
      //       dropdown_div.appendChild(drop_link);
      //     });
      //     li.appendChild(dropdown_div);
      //     if (index < 4) {
      //       ul.appendChild(li);
      //     } else {
      //       ul2.appendChild(li);
      //     }
      //     // console.log(dropdown_div)
      //   }
      //   //  console.log(ul)
      // });
      // //   console.log(ul)
      // //   console.log(ul2)
      // parent_div.appendChild(ul);
      // parent_div.appendChild(ul2);
      let div = doc.body.firstChild;
      div = div.outerHTML;
      this.$emit('setMenu',div)
      this.SaveMenuSection(div);
    },
    SaveMenuData(menu){
        var menu = {"menu":menu}  
        this.menuFileData=JSON.stringify(menu)
        // console.log(this.menuFileData)
        // this.SaveMenuFile(JSON.stringify(menu))
          // this.SaveDraft(false)
    },
  SaveMenuSection(html){
       var data = {"menu":this.menuData}  
        data = JSON.stringify(data)
        console.log(data)
       const site = this.$route.params.siteName;
       this.$apollo
          .mutate({
            mutation: SAVE_MENU_SECTION,
            variables: {
               site: site,
               data:data,
               html:html,
            },
          })
          .then((response) => {
             console.log(response)
          })
          .catch((error) => {
            console.log(error);
          });
    },
    initValues() {
      if (this.data.id) return;
      this.dataId = null;
    },
  },
  created(){
        this.$apollo
        .mutate({
          mutation: GET_MENU_TEMP,
           variables: {
            site: this.$route.params.siteName,
          },
        })
        .then((response) => {
           this.menu_temp = response.data.getMenuTemp.menu_temp
           var menu=JSON.parse(response.data.getMenuTemp.menu_data)
           this.$store.dispatch('setBuilderMenu', menu)
           localStorage.setItem('web-data-url',response.data.getMenuTemp.url)

          //  var menu_data=this.$store.getters.getBuilderMenu
          //  this.menuData=JSON.parse(menu_data).menu
          //  localStorage.setItem('menu-data',response.data.getMenuTemp.menu_data)
          //  console.log(this.menuData)
        })
        .catch((error) => {
          console.log(error);
        });
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 300px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
button.btn-async {
  background: rgba(var(--vs-warning), 0.15);
}

button.btn-delete {
  background: rgba(var(--vs-danger), 0.15);
}
.con-vs-dropdown--menu {
  z-index: 999999;
}
.menuHover{
  border-left: #5C52C0 4px solid;
  background: #F8F8F8;
}
</style>
